import { render, staticRenderFns } from "./ServiceArea.vue?vue&type=template&id=20e9944e&scoped=true&"
import script from "./ServiceArea.vue?vue&type=script&lang=js&"
export * from "./ServiceArea.vue?vue&type=script&lang=js&"
import style0 from "./ServiceArea.vue?vue&type=style&index=0&id=20e9944e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e9944e",
  null
  
)

export default component.exports